<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Grand Central Terminal and Penn Station</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr>
<td colspan="2"><a href="#/Foreword#For">Foreword</a></td>
</tr>
<tr>
<td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td>
</tr>
<tr>
<td colspan="2"><a href="#/Introduction#Intr">Introduction</a></td>
</tr>
<tr>
<td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td>
<td><span href="#/Chapter1#C1" title="Link target outside of Sample">Grand Central Terminal Statuary</span></td>
</tr>
<tr>
<td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td>
<td><span href="#/Chapter2#C2" title="Link target outside of Sample">Penn Station Statuary</span></td>
</tr>
<tr>
<td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td>
<td><span href="#/Chapter3#C3" title="Link target outside of Sample">Statues of Railroad Presidents</span></td>
</tr>
<tr>
<td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td>
<td><span href="#/Chapter4#C4" title="Link target outside of Sample">Grand Central Station Eagles at the Terminal</span></td>
</tr>
<tr>
<td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td>
<td><span href="#/Chapter5#C5" title="Link target outside of Sample">Grand Central Station Eagles at Other Locations</span></td>
</tr>
<tr>
<td><span href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td>
<td><span href="#/Chapter6#C6" title="Link target outside of Sample">Penn Station Eagles in New York State</span></td>
</tr>
<tr>
<td><span href="#/Chapter7#C7" title="Link target outside of Sample">7.</span></td>
<td><span href="#/Chapter7#C7" title="Link target outside of Sample">Penn Station Eagles in Other States</span></td>
</tr>
<tr>
<td><span href="#/Chapter8#C8" title="Link target outside of Sample">8.</span></td>
<td><span href="#/Chapter8#C8" title="Link target outside of Sample">Moynihan Train Hall</span></td>
</tr>
<tr>
<td colspan="2"><span href="#/Bibliography#Bib" title="Link target outside of Sample">Bibliography</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7bb86412